import { FC, useState } from 'react';

import { MainServiceApi } from '../../../../../lib/api/mainServiceApi';

import { FlashbarProps } from '@awsui/components-react';
import { ICreateSupportTopic } from '../../../../../interfaces/portal/supportTopic';

import View from './view';

interface IndexProps {
  refreshSupportTopicTable: () => void;
}

const CreateSupportTopicForm: FC<IndexProps> = ({
  refreshSupportTopicTable
}) => {
  const [flashBarItems, setFlashBarItems] = useState<
    FlashbarProps.MessageDefinition[]
  >([]);

  const formValues: ICreateSupportTopic = {
    topicName: ''
  };

  const handleSubmittedForm = async (data: ICreateSupportTopic) => {
    setFlashBarItems([
      {
        type: 'success',
        loading: true,
        content: 'Processing...'
      }
    ]);

    const api = new MainServiceApi();
    api
      .createSupportTopic(data)
      .then((resp) => {
        refreshSupportTopicTable();
        setFlashBarItems([
          {
            type: 'success',
            dismissible: true,
            dismissLabel: 'Dismiss message',
            onDismiss: () => setFlashBarItems([]),
            content: <>Support Topic has been created!</>
          }
        ]);
      })
      .catch(() => {
        setFlashBarItems([
          {
            type: 'error',
            dismissible: true,
            dismissLabel: 'Dismiss message',
            onDismiss: () => setFlashBarItems([]),
            content: <>Unable to create Support Topic!</>
          }
        ]);
      });
  };

  return (
    <View
      formValues={formValues}
      flashBarItems={flashBarItems}
      handleSubmittedForm={handleSubmittedForm}
    />
  );
};
export default CreateSupportTopicForm;
